import classnames from "classnames";
import CustomIcon from "../../../core/CustomIcon/CustomIcon";
import star from "../../../../assets/icons/star.svg";
import { nanoid } from "nanoid";
import classes from "../Banner.module.scss";

const CommentBanner = ({
  rating,
  comment,
  name,
  designation,
  pic,
  className,
}) => {
  const images = [];
  for (let i = 0; i < rating; i++) {
    images.push(
      <CustomIcon src={star} iconHeight={16} iconWidth={16} key={nanoid()} />
    );
  }
  return (
    <div className={classnames(className, classes.commentcontainer)}>
      <div className={classes.rating}>{images}</div>
      <div className={classes.comment}>{comment}</div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          marginTop: "24px",
        }}
      >
        <div className={classes.profilepic}>
          {pic ? (
            <CustomIcon src={pic} className={classnames("center")} />
          ) : (
            <div className={classnames("center", classes.name)}>
              {name.charAt(0)}
            </div>
          )}
        </div>
        <div>
          <div className={classes.name}>{name}</div>
          <div className={classes.designation}>{designation}</div>
        </div>
      </div>
    </div>
  );
};
export default CommentBanner;
